import React, { Component } from 'react'
import IPropTypes from 'react-immutable-proptypes'

import hocScrollbar from 'gnos-scrollbar'

import MenuItem from './components/MenuItem'

import hocConnect from './hocConnect'

import './style.scss'

@hocScrollbar({ smoothScrollbar: true, horizontal: true, overscroll: false })
@hocConnect
export default class Content extends Component {
    static propTypes = {
        modules: IPropTypes.list.isRequired,
    }

    shouldComponentUpdate(nextProps) {
        if (!this.props.modules.equals(nextProps.modules)) return true

        return false
    }

    render() {
        const { modules } = this.props

        const menuItems = modules.map((module) => {
            const key = module.get('key')

            return <MenuItem key={key} type={key} />
        })

        return <div className={'module-menu-content'}>{menuItems}</div>
    }
}
